import styled from 'styled-components';

import { GetMicrostoreProductsQuery, WarehouseReturnFragmentFragment } from 'data/__generated__';

export const ProductDetail = ({
    productFromCatalog,
    warehouseReturnProduct,
}: {
    productFromCatalog?: GetMicrostoreProductsQuery['getMicrostoreProducts'][number];
    warehouseReturnProduct: WarehouseReturnFragmentFragment['returnedProducts'][number];
}) => {
    return (
        <ProductContainer>
            <ProductName>
                {productFromCatalog
                    ? `${productFromCatalog?.name} - ${productFromCatalog?.brand} - ${productFromCatalog?.volume}`
                    : warehouseReturnProduct.productId}
            </ProductName>
            <ProductQuantity>Quantité: {warehouseReturnProduct.quantity}</ProductQuantity>
            <ProductQuantity>Quantité délivrée: {warehouseReturnProduct.deliveredQuantity ?? 'NA'}</ProductQuantity>
            <ProductQuantity>Quantité rangée: {warehouseReturnProduct.storedQuantity ?? 'NA'}</ProductQuantity>
        </ProductContainer>
    );
};

const ProductContainer = styled.div`
    margin-top: 10px;
`;
const ProductName = styled.div`
    font-weight: bold;
`;
const ProductQuantity = styled.div`
    margin-top: 5px;
`;
